import React from 'react'

import { FaPlay } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

import { Progress } from '../../../_components'
import {
  CourseCard as Card,
  CourseImage,
  CourseInfo,
  CourseMeta,
  LevelPill,
} from '../styles'

import type { CourseSummary } from './types'

interface CourseCardProps {
  course: CourseSummary
}

const CourseCard = ({ course }: CourseCardProps) => {
  const navigate = useNavigate()
  return (
    <Card>
      <CourseImage>
        <img src={course.image} alt="" aria-hidden="true" />
        <LevelPill>{course.level}</LevelPill>
        <button
          type="button"
          aria-label={`Reproducir ${course.title}`}
          onClick={() => navigate('/ruta-formacion')}
        >
          <FaPlay aria-hidden="true" />
        </button>
      </CourseImage>
      <CourseInfo>
        <h3>{course.title}</h3>
        <p>{course.teacher}</p>
        <Progress
          value={course.progress}
          label={`Progreso de ${course.title}`}
        />
        <CourseMeta>
          <span>{course.progress}% completado</span>
          <span>{course.lessons}</span>
        </CourseMeta>
      </CourseInfo>
    </Card>
  )
}

export default CourseCard
